import produce from "immer";
import {
  ADD_TERMINAL,
  ADD_TERMINAL_FAILURE,
  ADD_TERMINAL_SUCCESS,
  //
  DELETE_TERMINAL,
  DELETE_TERMINAL_FAILURE,
  DELETE_TERMINAL_SUCCESS,
  //
  EDIT_TERMINAL,
  EDIT_TERMINAL_FAILURE,
  EDIT_TERMINAL_SUCCESS,
  //
  FETCH_TERMINALS,
  FETCH_TERMINALS_FAILURE,
  FETCH_TERMINALS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingTerminals: false,
  terminal: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentTerminal: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
};

const TerminalReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_TERMINALS:
        draft.isFetchingTerminals = true;
        draft.terminal = [];
        break;
      case FETCH_TERMINALS_SUCCESS:
        draft.isFetchingTerminals = false;
        draft.terminal = action.payload;
        break;
      case FETCH_TERMINALS_FAILURE:
        draft.isFetchingTerminals = false;
        draft.terminal = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentTerminal = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentTerminal = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentTerminal = {};
        break;
      // Add
      case ADD_TERMINAL:
        draft.isSubmitting = true;
        break;
      case ADD_TERMINAL_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_TERMINAL_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_TERMINAL:
        draft.isSubmitting = true;
        break;
      case EDIT_TERMINAL_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_TERMINAL_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_TERMINAL:
        draft.isDeleting = true;
        break;
      case DELETE_TERMINAL_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_TERMINAL_FAILURE:
        draft.isDeleting = false;
        break;
      default:
        return state;
    }
  });

export default TerminalReducer;
